<template>
    <div id="team">
        <Topbar v-if="this.$store.state.topbar_actions_visible" @action="fnAction"></Topbar>
        <v-container class="main left">
            <v-layout row wrap class="section-container" id="basic">
                <v-flex xs12 sm6 md3 class="logo" >
                    <img :src="team.photo" />
                    <div class="legend">{{ team.club.name | checkParam }}</div>
                    <div class="legend cat">{{ team.category.max_age | checkParam }}</div>
                    <div
                        v-if="team.photo"
                        class="download"
                        @click="downloadImage(team.photo)"
                    ></div>
                </v-flex>
                <v-flex xs12 sm6 md9 class="info">
                    <v-container>
                        <v-layout row wrap class="section">
                            <v-flex xs12 class="name">{{ $t( "basic_info" ) }}</v-flex>
                            <v-flex xs12 md6>
                                <div class="label">{{ $t( "params.name" ) }}:</div><div class="value" v-if="team.name">{{ team.name | checkParam }}</div>
                                <div class="label">{{ $t("params.abbreviation_23") }}:</div><div class="value">{{ team.name_abre | checkParam }}</div>
                                <div class="label">{{ $t( "params.club" ) }}:</div><div class="value"><router-link class="club" :to="$root.entityUrl('club',team.club.id)" v-if="team.club">{{ team.club.name | checkParam }}</router-link></div>
                                <div class="label">{{ $t( "params.category" ) }}:</div><div class="value" v-if="team.category">{{ team.category.max_age | checkParam }}</div>
                                <div class="label">{{ $t( "event" ) }}:</div><div class="value">{{ $root.formatEventName( team.event.name, team.event.edition ) | checkParam }}</div>
                                <div class="label">{{ $t( "params.status" ) }}:</div><div class="value">{{ $store.getters['events/getStatusEntityByID']( parseInt(team.status) ).name | checkParam | i18n }}</div>
                                <div class="label">{{ $t( "params.mic_gestor" ) }}:</div><div class="value">{{ team.gestor | checkParam }}</div>
                                <div class="label empty">a</div><div class="value empty">a</div>
                                <div class="label">{{ $t( "params.estimate_players" ) }}:</div><div class="value">{{ team.estimate_players | checkParam }}</div>
                                <div class="label">{{ $t( "params.estimate_staff" ) }}:</div><div class="value">{{ team.estimate_staff | checkParam }}</div>
                                <div class="label">{{ $t( "params.estimate_acompanyants" ) }}:</div><div class="value">{{ team.estimate_acompanyants | checkParam }}</div>
                            </v-flex>
                            <v-flex xs12 md6>
                                <div class="label">{{ $t( "params.visible" ) }}:</div><div class="value">{{ team.visible | checkParam }}</div>
                                <div class="label">{{ $t( "params.insured" ) }}:</div><div class="value">{{ team.insured | insured }}</div>
                                <div class="label">{{ $t( "params.opening" ) }}:</div><div class="value">{{ team.opening | insured }}</div>
                                <div class="label">{{ $t( "params.finals" ) }}:</div><div class="value">{{ team.finals | insured }}</div>
                                <div class="label">{{ $t( "transfer.bus_service_type" ) }}:</div><div class="value">{{ getBusServiceLabel(team.transfer_options) }}</div>
                                <div class="label" v-if="event.type_id == 1">{{ $t( "params.finals_saturday" ) }}:</div><div class="value" v-if="event.type_id == 1">{{ team.finals_saturday | insured }}</div>
                                <div class="label">{{ $t( "params.invited" ) }}:</div><div class="value">{{ team.invited | checkParam }}</div>
                                <div class="label">{{ $t( "params.mode" ) }}:</div><div class="value">{{ getModeRegistered( team.mode ) | checkParam | i18n }}</div>
                                <div class="label">{{ $t( "params.how_meet" ) }}:</div><div class="value">{{  $t( team.how_meet.name) | checkParam }}</div>
                                <div class="label">{{ $t( "params.team_division" ) }}:</div><div class="value">{{  $t( getTeamDivision(team.division_id)) | checkParam }}</div>
                                <div class="label">{{ $t( "params.team_group" ) }}:</div><div class="value">{{  $t( team.division_group) | checkParam }}</div>
                                <div class="label">{{ $t( "params.registered_players" ) }}:</div><div class="value">{{ team.registered_players | checkParam }}</div>
                                <div class="label">{{ $t( "params.coefficient_age" ) }}:</div><div class="value">{{ team.coefficient | checkParam }}</div>
                                <div class="label">{{ $t( "params.registered_staff" ) }}:</div><div class="value">{{ team.registered_staff | checkParam }}</div>
                                <div class="label">{{ $t( "params.registered_acompanyants" ) }}:</div><div class="value">{{ team.registered_acompanyants | checkParam }}</div>
                            </v-flex>

                            <LastUpdate :data="team.user_modify"></LastUpdate>
                        </v-layout>
                    </v-container>
                </v-flex>
                <v-flex xs12 sm12 md12 class="info">
                    <v-container>
                        <v-layout row wrap class="section">
                            <v-flex @click="uniforms_visible = !uniforms_visible" xs12 class="name">{{ $t( "uniforms.label" ) }}</v-flex>
                            <v-flex xs6 v-if="team.local_uniform && uniforms_visible"><Equipment :equipment="team.local_uniform" :number="1" :is_preview="true"></Equipment></v-flex>
                            <v-flex xs6 v-if="team.away_uniform && uniforms_visible"><Equipment :equipment="team.away_uniform" :number="1" :is_preview="true"></Equipment></v-flex>
                        </v-layout>
                    </v-container>
                </v-flex>
                <v-flex xs12 sm12 md12 class="info">
                    <v-container>
                        <v-layout row wrap class="section">
                            <v-flex @click="players_visible = !players_visible" xs12 class="name">{{ $t( "players" ) }}<div @click="add('player')" class="add">{{ 'add' | i18n }}</div></v-flex>
                            <!-- <v-flex v-show="players_visible" md3 class="player" v-for="( player, key ) in team.players" :key="key">
                                <PlayerCardMini :player="player"></PlayerCardMini>
                            </v-flex> -->
                            <v-flex v-show="players_visible" md12 class="player">
                                <v-data-table
                                    :headers="players_headers"
                                    :items="team.players"
                                    class="elevation-1"
                                    :no-data-text="$t('vtf.datatable.no-data')"
                                    :no-results-text="$t('vtf.datatable.no-data')"
                                    :hide-default-footer="true"
                                    :pagination.sync="pagination"
                                    :rows-per-page-text="''"
                                    hide-actions
                                    item-key="id"
                                    :loading="false"
                                >
                                    <template v-slot:items="props">
                                    <tr>
                                        <td>{{ props.item.name + " " + props.item.surname }}</td>

                                        <td>{{ props.item.dni }}</td>

                                        <td v-if="player_position[ props.item.position ]">{{ player_position[ props.item.position ].name | i18n }}</td>
                                        <td v-else>-</td>

                                        <td>{{ props.item.number }}</td>

                                        <td @click="sendImageRight('player', props.item.id)">{{ props.item.image_right_status | parseBoolean }}</td>

                                        <td :id="'modality_' + props.item.id" @click="changeModality( props.item.id, props.item.modality, $event )"><div>{{ ( props.item.modality == '1' ? $t( 'mode.with_accomodation' ) : $t( 'mode.without_accomodation' ) ) }}</div></td>
                                        <td>
                                          <!-- If verification not yet done -->
                                          <v-chip v-if="props.item.verified === null" small outlined color="grey">
                                            {{ $t('verification.pending') }}
                                          </v-chip>

                                          <!-- If verified and OK -->
                                          <v-chip v-else-if="props.item.verified === true" small color="green">
                                            <span class="chip-text-force">{{ $t('verification.ok') }}</span>
                                          </v-chip>

                                          <!-- If verified = false (has errors) -->
                                          <div v-else class="d-inline-flex align-center">
                                            <v-chip
                                              small
                                              color="red"
                                              dark
                                              @click.stop="openVerificationPopup(props.item, 'players')"
                                            >
                                              <span class="chip-text-force">{{ $t('verification.errors') }}</span>
                                            </v-chip>

                                            <v-btn
                                              icon
                                              small
                                              class="ml-1"
                                              @click.stop="openVerificationPopup(props.item, 'players')"
                                            >
                                              <v-icon small>info_outline</v-icon>
                                            </v-btn>
                                          </div>
                                        </td>

                                        <td>
                                            <template v-if="props.item.edit">
                                                <v-btn small depressed color="#253554" dark @click="saveEditBudgetItem(props.item)">Guardar</v-btn>
                                            </template>
                                            <template v-else-if="false">
                                                <v-icon small @click="editBudgetItem(props.item)"
                                                >edit</v-icon
                                                >
                                                <v-icon small @click="deleteBudgetItem(props.item)"
                                                >delete</v-icon
                                                >
                                            </template>
                                            <template v-else >
                                                <div @click="assignPlayerMatch(props.item)">
                                                    <v-icon small  >add</v-icon>{{$t('assign_player_match')}}
                                                </div>
                                            </template>
                                        </td>
                                    </tr>
                                    </template>
                                    <template v-slot:headers="props">
                                    <tr class="table-header">
                                        <th
                                        role="columnheader"
                                        v-for="header in props.headers"
                                        :key="header.text"
                                        :class="['column']"
                                        >
                                        {{ header.text | i18n }}
                                        </th>
                                    </tr>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-flex>

                <v-flex xs12 sm12 md12 class="info">
                    <v-container>
                        <v-layout row wrap class="section">
                            <v-flex @click="players_visible = !players_visible" xs12 class="name">{{ $t( "staff" ) }}</v-flex>
                            <!-- <v-flex v-show="players_visible" md3 class="player" v-for="( player, key ) in team.players" :key="key">
                                <PlayerCardMini :player="player"></PlayerCardMini>
                            </v-flex> -->
                            <v-flex v-show="players_visible" md12 class="player">
                                <v-data-table
                                    :headers="staff_headers"
                                    :items="team.staff"
                                    class="elevation-1"
                                    :no-data-text="$t('vtf.datatable.no-data')"
                                    :no-results-text="$t('vtf.datatable.no-data')"
                                    :hide-default-footer="true"
                                    :pagination.sync="pagination"
                                    :rows-per-page-text="''"
                                    hide-actions
                                    item-key="id"
                                    :loading="false"
                                >
                                    <template v-slot:items="props">
                                    <tr>
                                        <td>{{ props.item.name + " " + props.item.surname }}</td>

                                        <td>{{ props.item.dni }}</td>

                                        <td >{{ $store.getters['persons/getContactTypeById']( props.item.type.id ).name | i18n }}</td>

                                        <td @click="sendImageRight('staff', props.item.id)">{{ props.item.image_right_status | parseBoolean }}</td>

                                        <td :id="'modality_' + props.item.id" @click="changeModality( props.item.id, props.item.modality, $event )"><div>{{ ( props.item.modality == '1' ? $t( 'mode.with_accomodation' ) : $t( 'mode.without_accomodation' ) ) }}</div></td>

                                        <td>
                                          <!-- If verification not yet done -->
                                          <v-chip v-if="props.item.verified === null" small outlined color="grey">
                                            {{ $t('verification.pending') }}
                                          </v-chip>

                                          <!-- If verified and OK -->
                                          <v-chip v-else-if="props.item.verified === true" small color="green" text-color="white">
                                            <span class="chip-text-force">{{ $t('verification.ok') }}</span>
                                          </v-chip>

                                          <!-- If verified = false (has errors) -->
                                          <div v-else class="d-inline-flex align-center">
                                            <v-chip
                                              small
                                              color="red"
                                              dark
                                              @click.stop="openVerificationPopup(props.item, 'staff')"
                                            >
                                              <span class="chip-text-force">{{ $t('verification.errors') }}</span>
                                            </v-chip>

                                            <v-btn
                                              icon
                                              small
                                              class="ml-1"
                                              @click.stop="openVerificationPopup(props.item, 'staff')"
                                            >
                                              <v-icon small>info_outline</v-icon>
                                            </v-btn>
                                          </div>
                                        </td>
                                        <!-- <td>
                                            <template v-if="props.item.edit">
                                                <v-btn small depressed color="#253554" dark @click="saveEditBudgetItem(props.item)">Guardar</v-btn>
                                            </template>
                                            <template v-else>
                                                <v-icon small @click="editBudgetItem(props.item)"
                                                >edit</v-icon
                                                >
                                                <v-icon small @click="deleteBudgetItem(props.item)"
                                                >delete</v-icon
                                                >
                                            </template>

                                        </td> -->
                                    </tr>
                                    </template>
                                    <template v-slot:headers="props">
                                    <tr class="table-header">
                                        <th
                                        role="columnheader"
                                        v-for="header in props.headers"
                                        :key="header.text"
                                        :class="['column']"
                                        >
                                        {{ header.text | i18n }}
                                        </th>
                                    </tr>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-flex>

                <v-flex xs12 sm12 md12 class="info">
                    <v-container>
                        <v-layout row wrap class="section">
                            <v-flex @click="players_visible = !players_visible" xs12 class="name">{{ $t( "acompanyants" ) }}</v-flex>
                            <!-- <v-flex v-show="players_visible" md3 class="player" v-for="( player, key ) in team.players" :key="key">
                                <PlayerCardMini :player="player"></PlayerCardMini>
                            </v-flex> -->
                            <v-flex v-show="players_visible" md12 class="player">
                                <v-data-table
                                    :headers="acompanyants_headers"
                                    :items="team.acompanyants"
                                    class="elevation-1"
                                    :no-data-text="$t('vtf.datatable.no-data')"
                                    :no-results-text="$t('vtf.datatable.no-data')"
                                    :hide-default-footer="true"
                                    :pagination.sync="pagination"
                                    :rows-per-page-text="''"
                                    hide-actions
                                    item-key="id"
                                    :loading="false"
                                >
                                    <template v-slot:items="props">
                                    <tr>
                                        <td>{{ props.item.name + " " + props.item.surname }}</td>

                                        <td>{{ props.item.dni }}</td>

                                        <td>{{ props.item.birthday | showDate }}</td>

                                        <!-- <td>
                                            <template v-if="props.item.edit">
                                                <v-btn small depressed color="#253554" dark @click="saveEditBudgetItem(props.item)">Guardar</v-btn>
                                            </template>
                                            <template v-else>
                                                <v-icon small @click="editBudgetItem(props.item)"
                                                >edit</v-icon
                                                >
                                                <v-icon small @click="deleteBudgetItem(props.item)"
                                                >delete</v-icon
                                                >
                                            </template>

                                        </td> -->
                                        <td>
                                          <!-- If verification not yet done -->
                                          <v-chip v-if="props.item.verified === null" small outlined color="grey">
                                            {{ $t('verification.pending') }}
                                          </v-chip>

                                          <!-- If verified and OK -->
                                          <v-chip v-else-if="props.item.verified === true" small color="green" text-color="white">
                                            <span class="chip-text-force">{{ $t('verification.ok') }}</span>
                                          </v-chip>

                                          <!-- If verified = false (has errors) -->
                                          <div v-else class="d-inline-flex align-center">
                                            <v-chip
                                              small
                                              color="red"
                                              dark
                                              @click.stop="openVerificationPopup(props.item, 'accompanists')"
                                            >
                                              <span class="chip-text-force">{{ $t('verification.errors') }}</span>
                                            </v-chip>

                                            <v-btn
                                              icon
                                              small
                                              class="ml-1"
                                              @click.stop="openVerificationPopup(props.item, 'accompanists')"
                                            >
                                              <v-icon small>info_outline</v-icon>
                                            </v-btn>
                                          </div>
                                        </td>
                                    </tr>
                                    </template>
                                    <template v-slot:headers="props">
                                    <tr class="table-header">
                                        <th
                                        role="columnheader"
                                        v-for="header in props.headers"
                                        :key="header.text"
                                        :class="['column']"
                                        >
                                        {{ header.text | i18n }}
                                        </th>
                                    </tr>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-flex>
                <!-- <v-flex xs12 sm12 md12 class="info">
                    <v-container>
                        <v-layout row wrap class="section">
                            <v-flex @click="staff_visible = !staff_visible" xs12 class="name">{{ $t( "staff" ) }}<div @click="add('staff')" class="add">{{ 'add' | i18n }}</div></v-flex>
                            <v-flex v-show="staff_visible" md3 class="staff" v-for="( staff, key ) in team.staff" :key="key">
                                <StaffCardMini :staff="staff"></StaffCardMini>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-flex> -->
                <v-flex xs12 sm12 md12 class="info">
                    <v-container>
                        <FinancesCard v-if="team.id" :page="'team'" :data="team"></FinancesCard>
                    </v-container>
                </v-flex>

                <v-flex xs12 sm12 md12 class="info" v-if="is_accomodated">
                    <v-container>
                        <v-layout row wrap class="section">
                            <v-flex xs12 class="name">{{ $t( "hotels.rooming" ) }}<div @click="addRooming = true" class="add">{{ 'add' | i18n }}</div></v-flex>
                            <div id="budget_control" :class="{ visible: hotels_visible }">
                                <v-switch
                                    v-model="hotels_visible"
                                    class="input"
                                    flat
                                    color="#8bc34a"
                                    :label="
                                    hotels_visible
                                        ? 'La informació d\'hotels està visible a la zona privada'
                                        : 'La informació d\'hotels està oculta a la zona privada'
                                    "
                                ></v-switch>
                            </div>
                            <v-flex md12 class="hotel">
                                <v-data-table
                                    :headers="rooming_headers"
                                    :items="Object.values(rooming)"
                                    class="elevation-1"
                                    :no-data-text="$t('vtf.datatable.no-data')"
                                    :no-results-text="$t('vtf.datatable.no-data')"
                                    :hide-default-footer="true"
                                    :pagination.sync="pagination"
                                    :rows-per-page-text="''"
                                    hide-actions
                                    :loading="false"
                                >
                                    <template v-slot:items="props">
                                        <tr style="height: 50px;">
                                            <td>{{ parseInt(props.item.visible) ? '★' : '' }}</td>
                                            <td v-if="props.item.hotel_id != null">{{ hotels[props.item.hotel_id].name }}</td>
                                            <td v-else></td>
                                            <td>{{ roomingStatus(props.item.status) }}</td>
                                            <td>{{ props.item.start_date | showDate }}</td>
                                            <td>{{ props.item.end_date | showDate }}</td>
                                            <td>{{ props.item.first_hotel_service_id ? $t(hotel_services[props.item.first_hotel_service_id].name) : '-' }}</td>
                                            <td>{{ props.item.last_hotel_service_id ? $t(hotel_services[props.item.last_hotel_service_id].name) : '-' }}</td>
                                            <td>{{ props.item.num_rooms_1pax }}</td>
                                            <td>{{ props.item.num_rooms_2pax }}</td>
                                            <td>{{ props.item.num_rooms_3pax }}</td>
                                            <td>{{ props.item.num_rooms_4pax }}</td>
                                            <td>{{ props.item.num_rooms_5pax }}</td>
                                            <td>{{ props.item.pax }}</td>
                                            <td>{{ props.item.observations }}</td>
                                            <td>{{ ( typeof props.item.alergy == "string" ? Boolean(parseInt(props.item.alergy)) : Boolean(props.item.alergy) ) | checkParam }}</td>
                                            <td style="text-align: center;">
                                                <v-icon v-if="props.item.hotel_id == null || true" @click="editRooming(props.item)">edit</v-icon>
                                                <v-icon v-if="props.item.hotel_id == null || true" @click="deleteRooming(props.item)">delete</v-icon>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-slot:headers="props">
                                        <tr class="table-header">
                                            <th
                                            role="columnheader"
                                            v-for="header in props.headers"
                                            :key="header.text"
                                            :class="['column']"
                                            >
                                            {{ header.text | i18n }}
                                            </th>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-flex>

                <v-flex xs12 sm12 md12 class="info">
                    <v-container>
                        <v-layout v-if="credential != undefined" row wrap class="section">
                            <v-flex @click="credentials_visible = !credentials_visible" xs12 class="name">{{ $t( "titles.credentials" ) }}</v-flex>
                            <template v-if="credential == 'empty' && credentials_visible">
                                <v-flex xs12 class="alert-info">{{ `credentials.empty` | i18n }}</v-flex>
                            </template>
                            <template v-else-if="credentials_visible">
                                <v-flex xs12 md6 v-if="credentials_visible">
                                    <div class="label">{{ $t( "credentials.pick_place" ) }}:</div>
                                    <div class="value" v-if="credential.location_id!='' && locations[credential.location_id] != undefined">{{ $t( 'credentials.hotel.'+locations[credential.location_id].name) | checkParam  }}</div>
                                    <div class="value" v-else>{{ credential.location_id | checkParam  }}</div>

                                    <div class="label">{{ $t( "credentials.pick_contact_name" ) }}:</div>
                                    <div class="value">{{ credential.contact_name | checkParam }}</div>
                                </v-flex>
                                <v-flex xs12 md6 v-if="credentials_visible">
                                    <div class="label">{{ $t( "credentials.pick_day" ) }}:</div>
                                    <div class="value" v-if="credential.daterange_id!='' && dateRange[credential.daterange_id] != undefined">{{ $t("credentials.daterange").replace("{date}", dateRange[credential.daterange_id].start.date).replace("{hour1}", dateRange[credential.daterange_id].start.hour).replace("{hour2}", dateRange[credential.daterange_id].end.hour) | checkParam }}</div>
                                    <div class="value" v-else>{{ credential.daterange | checkParam }}</div>

                                    <div class="label">{{ $t( "credentials.pick_contact_phone" ) }}:</div>
                                    <div class="value">{{ credential.contact_phone | checkParam }}</div>
                                </v-flex>
                            </template>

                        </v-layout>
                    </v-container>
                </v-flex>

                <v-flex xs12 sm12 md12 class="info">
                    <v-container>
                        <v-layout row wrap class="section">
                            <v-flex @click="transfer_visible = !transfer_visible" xs12 class="name">{{ $t( "titles.transfer" ) }} <div @click="addTravel" class="add">{{ 'add' | i18n }}</div></v-flex>
                            <div id="budget_control" :class="{ visible: b_transfer_visible }">
                                <v-switch
                                    v-model="b_transfer_visible"
                                    class="input"
                                    flat
                                    color="#8bc34a"
                                    :label="
                                    b_transfer_visible
                                        ? 'La secció TRANSFER està visible a la zona privada'
                                        : 'La secció TRANSFER està oculta a la zona privada'
                                    "
                                ></v-switch>
                            </div>
                            <div class="clean" style="width:100%;content:'';height:10px"></div>
                            <div id="budget_control" v-if="b_transfer_visible" :class="{ visible: b_arribada_visible }">
                                <v-switch
                                    v-model="b_arribada_visible"
                                    class="input"
                                    flat
                                    color="#8bc34a"
                                    :label="
                                    b_arribada_visible
                                        ? 'L\'equip pot introduir la informació d\'arribada a la zona privada'
                                        : 'L\'equip no pot introduir la informació d\'arribada a la zona privada'
                                    "
                                ></v-switch>

                            </div>
                            <div id="budget_control" v-if="b_transfer_visible" :class="{ visible: b_sortida_visible }" style="margin-left: 10px">
                                <v-switch
                                    v-model="b_sortida_visible"
                                    class="input"
                                    flat
                                    color="#8bc34a"
                                    :label="
                                    b_sortida_visible
                                        ? 'L\'equip pot introduir la informació de sortida a la zona privada'
                                        : 'L\'equip pot introduir la informació de sortida a la zona privada'
                                    "
                                ></v-switch>
                            </div>
                            <v-flex md12>
                                <v-data-table class="dataTable" id="travels" :headers="tableHeaders" :items="travels" :no-data-text="''" :no-results-text="''" :hideActions="true" :pagination="pagination" :custom-sort="sortTableTravels">
                                    <template v-slot:items="props">
                                        <tr style="height: 30px;">
                                            <td :class="{'shared': parseInt(props.item.shared) == 1 }"  style="width: 90px;">{{props.item.shared}} {{ props.item.travel_number }}</td>
                                            <td>{{ props.item.type | travelType }}</td>
                                            <td style="width: 50px;">{{ transport_modes[props.item.transport_mode] }}</td>
                                            <td style="width: 50px;">{{ props.item.transport_number }}</td>
                                            <td>{{ props.item.transport_company  }}</td>
                                            <!-- <td v-if="props.item.type == '1'">{{ props.item.destination.date }}</td>
                                            <td v-else>{{ props.item.origin.date }}</td>
                                            <td v-if="props.item.type == '1'">{{ props.item.destination.hour }}</td>
                                            <td v-else>{{ props.item.origin.hour }}</td> -->
                                            <td v-if="typeof props.item.origin !== 'undefined' && props.item.origin.entity_type!= '0'">{{ getLocationTransfer(props.item.origin.entity_type, props.item.origin.entity_id).name }}</td>
                                            <td v-else>{{props.item.origin.name}}</td>

                                            <td>{{ props.item.origin.date }}</td>
                                            <td>{{ props.item.origin.hour }}</td>
                                            <td>{{ props.item.destination.date }}</td>
                                            <td>{{ props.item.destination.hour }}</td>

                                            <td v-if="typeof props.item.destination !== 'undefined' && props.item.destination.entity_type!= '0'">{{ getLocationTransfer(props.item.destination.entity_type, props.item.destination.entity_id).name }}</td>
                                            <td v-else>{{props.item.destination.name}}</td>
                                            <td>{{ props.item.pax }}</td>
                                            <td v-if="props.item.cost != null">{{ props.item.cost }}{{coin}}</td>
                                            <td v-else>-</td>
                                            <td style="width: 150px;">{{ props.item.observations_int }}</td>
                                            <td style="text-align: center; width: 100px;">
                                                <v-icon @click="editTravel(props.item)">edit</v-icon>
                                                <v-icon @click="removeTravel(props.item)">delete</v-icon>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-slot:headers="props">
                                        <tr class="table-header">
                                            <th
                                            role="columnheader"
                                            v-for="header in props.headers"
                                            :key="header.text"
                                            :class="['column']"
                                            :title="header.text | i18n"
                                            >
                                            {{ header.text | i18n }}
                                            </th>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-flex>
                <v-flex xs12 sm12 md12 class="info" v-if="this.$store.getters.isEventSelected">
                  <v-flex xs12 sm12 md12 class="info">
                    <v-container>
                      <v-layout row wrap class="section" style="margin-bottom: 20px;">
                        <v-flex xs12 class="name">{{$t('volunteers.assigned_volunteers')}} </v-flex>
                      </v-layout>
                    </v-container>
                  </v-flex>
                  <v-container>
                    <v-flex xs12>
                      <v-layout row wrap class="assigned-teams">
                        <v-flex
                          v-for="(rel, index) in rel_volunteer_list"
                          :key="index"
                          xs12 sm6 md4
                          class="team-card volunteer-card"
                        >
                          <v-card class="pa-3" outlined tile>
                            <v-layout align-center>
                              <v-flex shrink>
                                <v-avatar size="40">
                                  <img
                                    :src="'/img/avatar.svg'"
                                    alt="Avatar"
                                  />
                                </v-avatar>
                              </v-flex>

                              <v-flex>
                                <div class="team-name">
                                  {{ rel.name }} {{ rel.surname }}
                                </div>
                                <div class="club-name">
                                  {{ rel.email }}<br>
                                  {{ rel.phone }}
                                </div>
                              </v-flex>

                              <v-flex shrink>
                                <v-btn icon small @click="promptDelete(rel)">
                                  <v-icon color="black">close</v-icon>
                                </v-btn>
                              </v-flex>
                            </v-layout>
                          </v-card>
                        </v-flex>
                      </v-layout>

                      <div v-if="!rel_volunteer_list || rel_volunteer_list.length == 0" class="value">
                        {{ $t("undefined") }}
                      </div>
                    </v-flex>
                  </v-container>
                </v-flex>

                <v-flex xs12 sm12 md12 class="info">
                  <v-container>
                    <v-layout row wrap class="section" style="margin-bottom: 20px;">
                      <v-flex xs12 class="name">{{$t('gamification')}} </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
                <div style="width: 100%; padding-left: 20px; margin-top: -40px">
                  <completion-steps
                    v-if="showDeadlines"
                    :value="deadlines"
                    :loading="completion_loading"
                    @save="persist"
                  />
                </div>

            </v-layout>
            <v-layout row wrap class="section-container" id="notes">
                <NoteList :notes="team.notes" :page="'team'" :id="id" @create_note="createNote"></NoteList>
            </v-layout>
        </v-container>
        <ContactList :contacts="team.staff" :entity="'team'" class="contact right"></ContactList>

        <v-dialog persistent v-model="addRooming" width="800">
          <v-card class="rooming popup">
            <v-card-title
              class="headline grey lighten-2"
              primary-title
              style="padding: 8px 10px; font-size: 20px !important;"
              >{{ 'hotels.add_rooming' | i18n }} - {{team.name}} ({{team.category.max_age}})
            </v-card-title>

            <v-card-text style="padding: 8px 10px;margin-top:10px;">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <v-container>
                        <v-layout row wrap class="section">
                            <v-flex xs6 md6 class="">
                                <div class="label inlineblock">{{ $t( "titles.hotel" ) }}:</div>
                                <div class="item inlineblock">
                                    <v-text-field v-if="newRooming.hotel_id == null" readonly hide-details disabled :value="'No assignat'"></v-text-field>
                                    <v-text-field v-else readonly hide-details disabled :value="hotels[newRooming.hotel_id].name"></v-text-field>
                                </div>
                            </v-flex>

                            <v-flex xs6 md6 class="">
                                <div class="label" style="width: 100%; margin-bottom: 10px;">{{ $t( "hotels.pax_rooming" ) }}:<span class="counter">{{total_pax}}</span></div>
                                <div class="label inlineblock" style="width: 50%">{{ $t( "params.pax" ) }}:<span class="counter">{{pax}}</span></div>
                                <div class="label inlineblock" style="width: 50%">{{ $t( "hotels.rooms" ) }}:<span class="counter">{{rooms}}</span></div>
                            </v-flex>

                            <v-flex xs6 md6 class="">
                                <div class="label">{{ $t( "hotels.entry_day" ) }}:</div>
                                <div class="item">
                                      <v-menu v-model="dialog_start_date" autocomplete="new-text" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field readonly hide-details v-bind:class="error.start_date ? 'input-error' : ''" append-icon="event" v-model="newRooming.parsedEntryDate" @click:append="dialog_start_date = true" @click="dialog_start_date = true" :placeholder="'DD/MM/YYYY' ">
                                            </v-text-field>
                                        </template>
                                        <v-date-picker v-model="newRooming.start_date" color="blue-grey lighten-2" @input="dialog_start_date = false, formatEntryDate()" :first-day-of-week="1" locale="ca"></v-date-picker>
                                    </v-menu>
                                </div>
                            </v-flex>
                            <v-flex xs6 md6 class="">
                                <div class="label">{{ $t( "hotels.departure_day" ) }}:</div>
                                <div class="item">
                                      <v-menu v-model="dialog_end_date" autocomplete="new-text" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field readonly hide-details v-bind:class="error.end_date ? 'input-error' : ''" append-icon="event" v-model="newRooming.parsedDepartureDate" @click:append="dialog_end_date = true" @click="dialog_end_date = true" :placeholder="'DD/MM/YYYY' ">
                                            </v-text-field>
                                        </template>
                                        <v-date-picker v-model="newRooming.end_date" color="blue-grey lighten-2" @input="dialog_end_date = false, formatDepartureDate()" :first-day-of-week="1" locale="ca"></v-date-picker>
                                    </v-menu>
                                </div>
                            </v-flex>
                            <v-flex xs6 md6 class="">
                                <div class="label">{{ $t( "hotels.first_hotel_service" ) }}:</div>
                                <v-select :items="hotel_servicesFirst" hide-details v-bind:class="error.first_hotel_service_id ? 'input-error' : ''" :item-text="item => $t( item.name )" item-value="id" v-model="newRooming.first_hotel_service_id"></v-select>
                            </v-flex>
                            <v-flex xs6 md6 class="">
                                <div class="label">{{ $t( "hotels.last_hotel_service" ) }}:</div>
                                <v-select :items="hotel_servicesLast" hide-details v-bind:class="error.last_hotel_service_id ? 'input-error' : ''" :item-text="item => $t( item.name )" item-value="id" v-model="newRooming.last_hotel_service_id"></v-select>
                            </v-flex>
                            <v-flex xs6 md6 class="">

                            </v-flex>
                            <v-flex xs12 md12 class="rooms">
                                <div class="label" style="margin-top: -30px; margin-bottom: 10px;">{{ $t( "config.label" ) }}:</div>
                                <div class="item">
                                    <div class="room inlineblock">
                                        <input :disabled="false && newRooming.hotel_id != null" :class="{ disabled: false && newRooming.hotel_id != null}" type="number" @focus="newRooming.num_rooms_1pax == 0 ? newRooming.num_rooms_1pax = '' : newRooming.num_rooms_1pax" @blur="newRooming.num_rooms_1pax == '' ? newRooming.num_rooms_1pax = 0 : newRooming.num_rooms_1pax" @input="calculatePaxRooms(1)" v-model="newRooming.num_rooms_1pax" class="inlineblock room-quantity"></input><span class="inlineblock">{{ $t( "hotels.individual" ) }}</span>
                                    </div>
                                    <div class="room inlineblock">
                                        <input :disabled="false && newRooming.hotel_id != null" :class="{ disabled: false && newRooming.hotel_id != null}" type="number" @focus="newRooming.num_rooms_2pax == 0 ? newRooming.num_rooms_2pax = '' : newRooming.num_rooms_2pax" @blur="newRooming.num_rooms_2pax == '' ? newRooming.num_rooms_2pax = 0 : newRooming.num_rooms_2pax" @input="calculatePaxRooms(2)" v-model="newRooming.num_rooms_2pax" class="inlineblock room-quantity"></input><span class="inlineblock">{{ $t( "hotels.double" ) }}</span>
                                    </div>
                                    <div class="room inlineblock">
                                        <input :disabled="false && newRooming.hotel_id != null" :class="{ disabled: false && newRooming.hotel_id != null}" type="number" @focus="newRooming.num_rooms_3pax == 0 ? newRooming.num_rooms_3pax = '' : newRooming.num_rooms_3pax" @blur="newRooming.num_rooms_3pax == '' ? newRooming.num_rooms_3pax = 0 : newRooming.num_rooms_3pax" @input="calculatePaxRooms(3)" v-model="newRooming.num_rooms_3pax" class="inlineblock room-quantity"></input><span class="inlineblock">{{ $t( "hotels.triple" ) }}</span>
                                    </div>
                                    <div class="room inlineblock">
                                        <input :disabled="false && newRooming.hotel_id != null" :class="{ disabled: false && newRooming.hotel_id != null}" type="number" @focus="newRooming.num_rooms_4pax == 0 ? newRooming.num_rooms_4pax = '' : newRooming.num_rooms_4pax" @blur="newRooming.num_rooms_4pax == '' ? newRooming.num_rooms_4pax = 0 : newRooming.num_rooms_4pax" @input="calculatePaxRooms(4)" v-model="newRooming.num_rooms_4pax" class="inlineblock room-quantity"></input><span class="inlineblock">{{ $t( "hotels.quadruple" ) }}</span>
                                    </div>
                                    <div class="room inlineblock">
                                        <input :disabled="false && newRooming.hotel_id != null" :class="{ disabled: false && newRooming.hotel_id != null}" type="number" @focus="newRooming.num_rooms_5pax == 0 ? newRooming.num_rooms_5pax = '' : newRooming.num_rooms_5pax" @blur="newRooming.num_rooms_5pax == '' ? newRooming.num_rooms_5pax = 0 : newRooming.num_rooms_5pax" @input="calculatePaxRooms(5)" v-model="newRooming.num_rooms_5pax" class="inlineblock room-quantity"></input><span class="inlineblock">{{ $t( "hotels.quintuple" ) }}</span>
                                    </div>
                                </div>
                            </v-flex>
                            <v-flex xs6 md6>
                                <div class="label">{{ $t( "params.status" ) }}:</div>
                                <v-select :items="rooming_status" hide-details :item-text="item => $t( item.name )" item-value="id" v-model="newRooming.status"></v-select>
                            </v-flex>
                            <v-flex xs6 md6>
                                <div class="label">{{ $t( "params.alergy" ) }}:</div>
                                <v-checkbox
                                color="#8bc34a"
                                class="filter-checkbox"
                                hide-details
                                v-model="newRooming.alergy"
                                ></v-checkbox>
                            </v-flex>
                            <v-flex xs12 md12>
                              <div class="label">{{ $t( "params.observations" ) }}:</div>
                              <v-textarea auto-grow v-model="newRooming.observations"></v-textarea>
                            </v-flex>
                            <v-flex xs12 md12>
                                <div class="label error" v-if="error.visible">{{ $t('teams.errors.rooming_visible_msg') }}</div>
                                <div class="label">{{ $t( "teams.rooming_visible" ) }}:</div>
                                <v-checkbox
                                color="#8bc34a"
                                class="filter-checkbox"
                                hide-details
                                v-model="newRooming.visible"
                                ></v-checkbox>
                            </v-flex>
                        </v-layout>
                    </v-container>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-btn color="primary" flat @click="closeRooming()">{{
                `close` | i18n
              }}</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="saveRooming()">{{
                `add` | i18n
              }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <div>
            <!-- Your form / buttons etc -->

            <!-- Snackbar -->
            <v-snackbar
              v-model="snackbar.show"
              :timeout="snackbar.timeout"
              :color="snackbar.color"
              bottom
              right
            >
              {{ snackbar.text }}
            </v-snackbar>
          </div>
        <assign-volunteer-team-dialog
        :value="assignTeamDialogVisible"
        @assign="handleAssignTeamToVolunteer"
        @input="assignTeamDialogVisible = false"
        :loading="isAssigningTeam"
        ref="assignTeamVDialog"
        :team-id="$route.params.id"
        :team-name="team.name"
        :club-name="team.club.name"
        :category="team.category.max_age"
        :shield="team.club.shield"
        />
        <delete-rel-entity-event-dialog
        :value="showDeleteDialog"
        @confirm="confirmDeleteVolunteer"
        @input="showDeleteDialog = false"
        showDeleteDialog: false
        :subtitle="$t('volunteers.delete_rel_volunteer_confirm')"
        :title="$t('volunteers.delete_rel_volunteer_title')"
        />
        <verification-dialog
          v-model="showVerificationDialog"
          :selected-item="selectedItem"
          :selected-item-type="selectedItemType"
          @validate="handleVerificationSave"
          @apply="handleVerificationApply"
        />
    </div>
</template>

<script>

import i18n from '@/i18n'
import ContactList from '@/components/ui/ContactList'
import NoteList from '@/components/ui/NoteList'
import Topbar from '@/components/ui/Topbar'
import FinancesCard from '@/components/ui/FinancesCard'
import Equipment from '@/components/ui/Equipment'
import LastUpdate from '@/components/ui/LastUpdate'
import CompletionSteps from '@/components/ui/CompletionSteps'
import AssignVolunteerTeamDialog from '@/components/ui/AssignVolunteerTeamDialog.vue'
import DeleteRelEntityEventDialog from '@/components/ui/DeleteRelEntityEventDialog'
import VerificationDialog from '@/components/ui/VerificationDialog.vue'

export default {
  name: 'CardTeam',
  components: { ContactList, NoteList, Topbar, Equipment, FinancesCard, LastUpdate, CompletionSteps, AssignVolunteerTeamDialog, DeleteRelEntityEventDialog, VerificationDialog },
  props: { },
  data () {
    return {
      completion_loading: false,
      showVerificationDialog: false,
      selectedItem: null,
      selectedItemType: null,
      snackbar: {
        show: false,
        text: '',
        color: 'white',
        timeout: 3000
      },
      dates: {
        payment: null,
        dates: null,
        players: null,
        docs: null
      },
      menus: {
        payment: false,
        dates: false,
        players: false,
        docs: false
      },
      showDeleteDialog: false,
      isAssigningTeam: false,
      assignTeamDialogVisible: false,
      id: this.$route.params.id,
      players_visible: true,
      staff_visible: true,
      uniforms_visible: true,
      credentials_visible: true,
      transfer_visible: true,
      hotels_visible: false,
      credential: undefined,
      is_accomodated: false,
      locations: '',
      dateRange: '',
      b_transfer_visible: false,
      b_arribada_visible: false,
      b_sortida_visible: false,
      tableHeaders: [
        { text: '#ID', value: 'travel_number' },
        { text: i18n.t('params.type'), value: 'type' },
        { text: i18n.t('params.transport_mode'), value: 'transport_mode', sortable: true },
        { text: i18n.t('params.transport_number'), value: 'transport_number', sortable: false },
        { text: i18n.t('params.transport_company'), value: 'transport_company', sortable: true },
        { text: i18n.t('params.origin_place'), value: 'origin.entity_id', sortable: true },
        { text: i18n.t('params.origin_date'), value: 'origin.date', sortable: true },
        { text: i18n.t('params.origin_hour'), value: 'origin.hour', sortable: true },
        { text: i18n.t('params.destination_date'), value: 'origin.date', sortable: true },
        { text: i18n.t('params.destination_hour'), value: 'origin.hour', sortable: true },
        { text: i18n.t('params.destination'), value: 'destination.entity_id', sortable: true },
        { text: i18n.t('params.n_pax'), value: 'pax', sortable: true },
        { text: i18n.t('params.cost'), value: 'cost', sortable: true },
        { text: i18n.t('params.observations'), value: 'observations', sortable: false, width: '150px', style: 'width: 150px;' },
        { text: i18n.t('params.actions'), sortable: false }
      ],
      players_headers: [
        { text: 'params.name', value: 'name', sortable: true },
        { text: 'params.dni', value: 'dni', sortable: true },
        { text: 'params.position', value: 'position', sortable: true },
        { text: 'params.number', value: 'number', sortable: true },
        { text: 'params.image_right', value: 'image_right_status', sortable: true },
        { text: 'titles.modality', value: 'modality', sortable: true },
        { text: 'params.verification', value: 'verified', sortable: false },
        { text: 'params.actions', sortable: false }
      ],
      staff_headers: [
        { text: 'params.name', value: 'name', sortable: true },
        { text: 'params.dni', value: 'dni', sortable: true },
        { text: 'params.cargo', value: 'cargo', sortable: true },
        { text: 'params.image_right', value: 'image_right_status', sortable: true },
        { text: 'titles.modality', value: 'modality', sortable: true },
        { text: 'params.verification', value: 'verified', sortable: false }
      ],
      acompanyants_headers: [
        { text: 'params.name', value: 'name', sortable: true },
        { text: 'params.dni', value: 'dni', sortable: true },
        { text: 'params.birthday', value: 'birthday', sortable: true },
        { text: 'params.verification', value: 'verified', sortable: false }
      ],
      rooming_headers: [
        { text: 'params.visible', value: 'visible', sortable: true },
        { text: 'titles.hotel', value: 'hotel_id', sortable: true },
        { text: 'params.status', value: 'status', sortable: true },
        { text: 'hotels.entry_day', value: 'start_date', sortable: true },
        { text: 'hotels.departure_day', value: 'end_date', sortable: true },
        { text: 'hotels.first_hotel_service', value: 'first_hotel_service_id', sortable: true },
        { text: 'hotels.last_hotel_service', value: 'last_hotel_service_id', sortable: true },
        { text: 'I', value: 'num_rooms_1pax', sortable: true },
        { text: 'II', value: 'num_rooms_2pax', sortable: true },
        { text: 'III', value: 'num_rooms_3pax', sortable: true },
        { text: 'IV', value: 'num_rooms_4pax', sortable: true },
        { text: 'V', value: 'num_rooms_5pax', sortable: true },
        { text: 'params.pax', value: 'pax', sortable: true },
        { text: 'params.observations', value: 'observations', sortable: true },
        { text: 'params.alergy', value: 'alergy', sortable: true },
        { text: 'params.actions', sortable: false }
      ],
      pagination: {
        sortBy: 'name',
        descending: true,
        rowsPerPage: -1,
        page: 1,
        totalItems: 0,
        totalFilteredItems: 0
      },
      pagination_travels: { sortBy: [{ key: 'origin.date', order: 'asc' }, { key: 'origin.hour', order: 'asc' }], descending: false, rowsPerPage: -1 },

      // ROOMING
      addRooming: false,
      dialog_start_date: false,
      dialog_end_date: false,
      newRooming: {
        num_rooms_1pax: 0,
        num_rooms_2pax: 0,
        num_rooms_3pax: 0,
        num_rooms_4pax: 0,
        num_rooms_5pax: 0,
        status: '1',
        alergy: false,
        visible: false,
        start_date: false,
        end_date: false,
      },
      error: {
        start_date: false,
        end_date: false,
        first_hotel_service_id: false,
        last_hotel_service_id: false,
        visible: false
      },

      // FORM VARIABLES
      total_pax: 0,
      pax: 0,
      rooms: 0
    }
  },
  computed: {

    current_event() {
        return this.$store.getters['events/getCurrentEvent']();
    },

    rel_volunteer_list() {
        return this.$store.getters['teams/getRelVolunteerList']();
    },
    showDeadlines(){
      return this.team ? !!Number(this.team.show_deadlines) : false
    },
    deadlines(){
      return this.team && this.team.deadlines ? this.team.deadlines : []
    },
    coin(){
        let event = this.$store.getters[ 'events/getCurrentEvent' ]()
        return event.type_id == 15 ? '$' : '€'
    },
  event(){
    let event = this.$store.getters[ 'events/getCurrentEvent' ]()
    if(!this.newRooming.start_date && !this.newRooming.end_date){
        this.newRooming.start_date = event.start_date
        this.newRooming.end_date = event.end_date
    }
    return event
  },
    team () {
      var oTeam = { ...this.$store.getters[ 'teams/get_by_id' ](this.$route.params.id) }
      if (!oTeam) oTeam = {}

      oTeam.club = (typeof oTeam.club === 'undefined') ? {} : oTeam.club
      oTeam.category = (typeof oTeam.category === 'undefined') ? {} : oTeam.category

      oTeam.notes = ObjectToArray(oTeam.notes)
      oTeam.notes.sort(function (n1, n2) {
        if (moment(n1.last_update).valueOf() < moment(n2.last_update).valueOf()) return 1
        return -1
      })

      oTeam.contacts = ObjectToArray(oTeam.contacts)

      oTeam.event = (typeof oTeam.event === 'undefined') ? { name: '', edition: '' } : oTeam.event
      oTeam.how_meet = (typeof oTeam.how_meet === 'undefined') ? {} : oTeam.how_meet

      oTeam.staff = ObjectToArray(oTeam.staff)

      if (typeof oTeam.gestor_id) {
        var gestor = this.$store.getters[ 'user/getList' ](oTeam.gestor_id)
        oTeam.gestor = (typeof gestor !== 'undefined') ? gestor.name : ''
      }

      this.b_transfer_visible = oTeam.transfer_visible == '1'
      setTimeout(()=>{
          this.b_arribada_visible = oTeam.arribada_visible == '1'
          this.b_sortida_visible = oTeam.sortida_visible == '1'
      }, 200)

      this.hotels_visible = oTeam.hotels_visible == '1'

      oTeam.players = ObjectToArray(oTeam.players)
      oTeam.staff = ObjectToArray(oTeam.staff)
      oTeam.acompanyants = ObjectToArray(oTeam.acompanyants)

      this.total_pax = oTeam.n_housed

      return oTeam
    },

    travels () {
      var list = Object.values(this.$store.getters['travels/getList']())
      var findArrive = list.find(obj => {
        return obj.type == 1
      })
      findArrive ? this.arrive = findArrive : this.arrive = ''

      var findDesparture = list.find(obj => {
        return obj.type == 3
      })
      findDesparture ? this.departure = findDesparture : this.departure = ''

      list.sort((a, b) => {
        if (a.origin && b.origin) {
          return moment(a.origin.date + ' ' + a.origin.hour, 'DD-MM-YYYY HH:mm').valueOf() < moment(b.origin.date + ' ' + b.origin.hour, 'DD-MM-YYYY HH:mm').valueOf() ? 1 : -1
        } else if (!a.origin) {
          return -1
        }
        return 1
      })

      return list
    },

    locationsTransfer () {
      return this.$store.getters['travels/getLocations']()
    },

    transport_modes () {
      var oOptions = this.$store.getters.getTransportMode()
      var aResult = []
      for (var k in oOptions) {
        aResult[oOptions[k].id] = i18n.t('travels.transport_mode.' + oOptions[k].name)
      }
      return aResult
    },

    player_position () {
      return this.$store.getters['persons/getPositions']()
    },

    rooming () {
      return this.$store.getters[ 'teams/getRooming' ]
    },

    hotel_services () {
      return this.$store.getters.getHotelServices()
    },

    hotels () {
      return this.$store.getters[ 'hotels/getListKeyId' ]()
    },

    hotel_servicesFirst () {
      var data = this.$store.getters.getHotelServices()
      return Object.values(data).filter(item => item.type == '1')
    },

    hotel_servicesLast () {
      var data = this.$store.getters.getHotelServices()
      return Object.values(data).filter(item => item.type == '2')
    },

    rooming_status () {
      return Object.values(this.$store.getters['hotels/getRoomingStatus']())
    }

    //   contacts() {
    //       return [ { name: 'Manolito García', tel: '2432343248', 'role': 'Responsable', 'email': 'sadsads@sadsd.com' }, { name: 'Mario Martinez', tel: '2432343248', 'role': 'Responsable', 'email': 'sadsads@sadsd.com' } ];
    //   }
  },
  created () {
    this.loadData()
  },
  methods: {
    getBusServiceLabel(transferOptions) {
      if (!transferOptions || transferOptions === 'null') {
        return i18n.t('nsnc')
      }

      const wantBus = transferOptions.want_bus_service
      const type = transferOptions.bus_service_type

      if (!wantBus) return i18n.t('nsnc')
      if (wantBus === 'no') return i18n.t('transfer.no_bus_service')

      if (wantBus === 'yes') {
        switch (type) {
          case 'arrival':
            return i18n.t('transfer.bus_arrival_only')
          case 'departure':
            return i18n.t('transfer.bus_departure_only')
          case 'both':
            return i18n.t('transfer.bus_arrival_departure')
          case 'other':
            return i18n.t('transfer.bus_other_days')
          default:
            return i18n.t('transfer.bus_service_requested')
        }
      }

      return i18n.t('nsnc')
    },
    async handleVerificationSave (data) {
      console.log('Canceled verification results:', data)
      const id = data.item.id
      const type = data.itemType
      const teamId = this.$route.params.id
        const payload = {
            id,
            team_id: teamId,
            type,
        };
        try {
            const response = await this.$store.dispatch('teams/updatePersonValidation', payload);
            await this.loadData(); // refresh view
            this.toast(i18n.t('verification.ok'), 'white');
        } catch (e) {
            this.$popup.alert({ message: this.$t('error.generic'), btnSuccess: this.$t('accept') });
        } finally {
            this.$overlay.hide();
            this.showDeleteDialog = false;
        }
    },
    async handleVerificationApply (data) {
      console.log('Saved verification results:', data)
      const id = data.item.id
      const type = data.itemType
      const teamId = this.$route.params.id
        const payload = {
            id,
            team_id: teamId,
            type,
            errors: data.item.errors
        };
        console.log('payload', payload)
        try {
            const response = await this.$store.dispatch('teams/updatePersonData', payload);
            await this.loadData(); // refresh view
            this.toast(i18n.t('verification.ok'), 'white');
        } catch (e) {
            this.$popup.alert({ message: this.$t('error.generic'), btnSuccess: this.$t('accept') });
        } finally {
            this.$overlay.hide();
            this.showDeleteDialog = false;
        }
    },
    openVerificationPopup (item, itemType) {
      console.log('Opening verification popup for item:', item)
      this.selectedItem = item
      this.selectedItemType = itemType
      this.showVerificationDialog = true
    },
    promptDelete(rel) {
        this.volunteerToDelete = rel;
        this.showDeleteDialog = true;
    },
    async confirmDeleteVolunteer() {
        if (!this.volunteerToDelete) return;

        const payload = {
            volunteer_id: this.volunteerToDelete.volunteer_id,
            event_id: this.current_event.id,
            entity_type: 2,
            entity_id: this.id
        };
        try {
            const response = await this.$store.dispatch('volunteers/delete_volunteer_team_assignment', payload);
            await this.loadData(); // refresh view
            if(response.status){
              this.toast(i18n.t('volunteers.volunteer_unassigned_successfully'), 'white');
            } else {
              this.toast(response.error.message, 'red', 5000)
            }
        } catch (e) {
            this.$popup.alert({ message: this.$t('error.generic'), btnSuccess: this.$t('accept') });
        } finally {
            this.$overlay.hide();
            this.teamToDelete = null;
            this.showDeleteDialog = false;
        }
    },
    fnAssignTeamToVolunteer () {
        const team = this.$route.params.id;
        this.assignTeamDialogVisible = true;
    },
    async handleAssignTeamToVolunteer({ volunteerId }) {
        const data = {
            volunteer_id: volunteerId,
            event_id: this.$store.getters['events/getCurrentEvent']().id,
            entity_type: 2, // 2 is the type for teams
            entity_id: this.$route.params.id
        }
        this.isAssigningTeam = true

        try {
            const response = await this.$store.dispatch('volunteers/assign_volunteer_to_team', data)
            let error = ''
            if(!response.status){
              error = response.error.message
            }
            if(response.status){
              this.toast(i18n.t('volunteers.volunteer_assigned_successfully'), 'white')
            } else {
              this.toast(error, 'red', 5000)
            }

            this.assignTeamDialogVisible = false
            this.loadData(true)
        } catch (error) {
            console.log('notify', { type: 'error', message: 'Failed to create' })
        } finally {
            this.isAssigningTeam = false
            this.$refs.assignTeamVDialog.resetState()
        }
    },
    toast (text, color = 'white', timeout = 3000) {
      this.snackbar.text = text
      this.snackbar.color = color
      this.snackbar.timeout = timeout
      this.snackbar.show = true
    },
    async persist (payload) {
      try {
        this.completion_loading = true
        const teamId = this.$route.params.id
        await this.saveSteps({ teamId, steps: payload })
        this.toast(i18n.t('saved_successfully'), 'white')
      } catch (err) {
        this.toast('Save failed', 'red', 5000)
      } finally {
        this.completion_loading = false
      }
    },
    async saveSteps ({ teamId, steps }) {
      // return the dispatch so callers can await
      return this.$store.dispatch('teams/updateDeadlines', { team_id: teamId, steps });
    },
    sendImageRight(type, id){
        var self = this
        let person = false
        if( type == 'staff' ){
            const persons = this.team.staff.filter( p => p.id == id)
            if(persons.length > 0) person = persons[0]
        }
        if( type == 'player' ){
            const persons = this.team.players.filter( p => p.id == id)
            if(persons.length > 0) person = persons[0]
        }
        if( person && (parseInt(person.image_right_status) == 0 || !person.image_right_status) ){
            this.$popup.confirm({
                message: i18n.t('persons.send_image_right'),
                btnSuccess: i18n.t('accept'),
                btnError: i18n.t('cancel')
            }, function () {
                self.$store
                .dispatch("persons/sendImageRight", {
                event_id: self.team.event_id,
                id: id,
                type: type,
                })
                .then((response) => {
                });
            })
        }
    },

    assignPlayerMatch(player){
        var self = this
        this.$card.assignPlayerMatch({
            event_id: this.team.event_id,
            player: player,
            team: this.team,
            callBack: function (plugin, params, store) {
                let match_id = plugin.$children[0].match_id
                let team_id = plugin.$children[0].team_id
                let player_id = plugin.params.player.id

                store.dispatch('competition/assignplayermatch', {match_id: match_id, team_id: team_id, player_id: player_id}).then(match =>{
                    self.$popup.alert({
                        message: i18n.t("assign_player_match"),
                        btnSuccess: i18n.t("accept"),
                    });
                    self.$card.close();
                })
            }
        })
    },

    loadData () {
      this.$overlay.loading()

      if (document.getElementById('main-content')) {
        document.getElementById('main-content').classList.remove('full_separator')
      }

      this.$store.commit('setTopbarActionsVisible', true)
      this.$store.commit('setMenuVisible', true)

      var id = this.$route.params.id
      var self = this
      var event_id = (this.$store.getters.isEventSelected) ? this.$store.getters[ 'events/getCurrentEvent' ]().id : false

      self.$store.dispatch('travels/loadTravelInfo').then(function () {
        self.$store.dispatch('travels/loadTeamTravels', { team_id: id }).then(function () {
          self.$store.dispatch('teams/load_by_id', { id: id }).then(function (team) {
            self.$store.dispatch('clubs/load_by_id', { id: team.club.id, event: event_id }).then(function () {
              self.$store.dispatch('hotels/loadList', { page_options: { num_page: -1, num_items: -1 }, event: event_id }).then(function () {
                self.$store.dispatch('teams/loadRooming', { team_id: id, event_id: event_id }).then(function () {
                  self.$store.dispatch('facilitys/loadList', { page_options: { num_page: -1, num_items: -1 }, event: event_id }).then(function () {
                    self.$store.dispatch('volunteers/loadList', { page_options: { num_page: -1, num_items: -1 }, event: event_id }).then(function () {
                      self.$store.dispatch('teams/fetchRelVolunteerList', { id: id, event: event_id }).then(function () {
                        self.$overlay.hide()
                      })
                    })
                  })
                })
              })
            })
          })
        })
      })
    },

    createNote () {
      this.$card.note({ current_page: 'team', current_id: this.$route.params.id })
    },

    getCountry (id) {
      if (id) {
        return { ...this.$store.getters.getCountryByID(id) }
      }
      return false
    },

    fnAction (emit) {
      if (typeof emit.action === 'undefined' || emit.action == null) return
      switch (emit.action) {
        case 'remove': this.fnRemove(emit.params)
          break
        case 'create_note': this.createNote(emit.params)
          break
        case 'user_create': this.fnCreateUser(emit.params)
          break
        case 'rel_club_event': this.fnRelClubEvent(emit.params)
          break
        case 'destroy': this.fnDestroy(emit.params)
          break
        case 'preview_teamzone': this.$root.fnGoToTeamZones(2)
          break
        case 'export_starters': this.fnExportStarters(emit.params)
          break
        case 'print_myteams': this.fnPrintMyTeams(emit.params)
          break
        case 'send_image_right': this.fnSendImageRight(emit.params)
            break
        case 'mic_assign_team_to_volunteer':
            this.fnAssignTeamToVolunteer();
            break;``
      }
    },

    fnRemove () {
      var self = this
      this.$popup.confirm({
        message: i18n.t('teams.remove_message'),
        btnSuccess: i18n.t('accept'),
        btnError: i18n.t('cancel')
      }, function () {
        self.$store.dispatch('teams/remove', self.id).then(function () {
          var event = (self.$store.getters.isEventSelected) ? self.$store.getters[ 'events/getCurrentEvent' ]() : false
          var page = (event) ? 'event_' : ''
          page = page + 'teams'

          self.$router.push({ name: page, params: { event: self.$root.formatEventUrl(event.name, event.edition).replace('/event/', '') } })
        })
      })
    },

    fnCreateUser () {
      var self = this
      this.$card.userZE({ team_id: this.$route.params.id,
        event_id: this.$store.getters[ 'events/getCurrentEvent']().id,
        callBack: function (plugin, params, store) {
          self.$store.dispatch('teams/createUserZE', { team_id: plugin.params.team.value, event: plugin.params.event.value, username: plugin.params.username.value, name: plugin.params.name.value, password: sha256(plugin.params.password.value), email: plugin.params.email.value, language: plugin.params.lang.value }).then(
            function () {
              self.$popup.alert({ message: i18n.t('clubs.created_rel_club_event'), btnSuccess: i18n.t('accept') })
              self.$card.close()
            }
          ).catch(
            function (e) {
              self.$popup.alert({ message: i18n.t('errors.' + e), btnSuccess: i18n.t('accept') })
            }
          )
        } })
    },

    fnExportStarters () {
      window.open(
        process.env.VUE_APP_API_URL +
                'team/' +
                this.$route.params.id +
                '/event/' +
                this.$store.getters[ 'events/getCurrentEvent']().id +
                '/starters/' +
                localStorage.token
      )
    },

    fnPrintMyTeams () {
      // window.open(
      //     process.env.VUE_APP_API_URL +
      //     "team/" +
      //     this.$route.params.id +
      //     "/event/" +
      //     this.$store.getters[ 'events/getCurrentEvent']().id +
      //     "/myteams?authorization=" + localStorage.token + "&lang=ca"
      // );
      this.$popup.myTeams({
        team_id: this.$route.params.id,
        event_id: this.$store.getters[ 'events/getCurrentEvent']().id,
        btnSuccess: i18n.t('accept'),
        btnError: i18n.t('cancel')
      }, function () {

      },
      function () {

      })
    },

    fnSendImageRight() {
        var self = this
        this.$popup.confirm(
            {
              message: i18n.t('teams.team_confirm_send_image_right'),
              btnSuccess: i18n.t('accept'),
              btnError: i18n.t('cancel')
            },
            function () {
              self.$overlay.loading()
              var path = 'teams/sendImageRight'
              self.$store
                .dispatch(path, {
                  event_id: self.$store.getters[ 'events/getCurrentEvent']().id,
                  team_id: self.$route.params.id
                })
                .then(function () {
                    self.$overlay.hide()
                })
            },
            function () {
            }
        )
    },

    getModeRegistered (team_mode) {
      var aModes = this.$store.getters.getModeRegistered()
      var oMode = false
      aModes.forEach(mode => {
        if (mode.id == team_mode) oMode = mode
      })
      if (!oMode) {
        oMode = { name: i18n.t('undefined') }
        this.is_accomodated = false
      } else {
        oMode.name.match('without_accomodation') ? this.is_accomodated = false : this.is_accomodated = true
      }

      if ((oMode.name.match('without_accomodation')) && !this.credential) {
        var self = this
        var event_id = this.$store.getters[ 'events/getCurrentEvent']().id
        this.$store.dispatch('teams/loadCredentialsInfo', { event_id: event_id }).then(function (data) {
          self.$store.dispatch('teams/loadCredential', { team_id: self.id }).then(function (response) {
            if (response.status) {
              if (typeof response.data !== 'undefined' && Object.values(response.data).length > 0) {
                self.credential = { ...response.data }
              } else {
                self.credential = 'empty'
              }
              return i18n.t(oMode.name)
            } else {
              self.credential = { 'daterange_id': '', 'location_id': '', 'contact_name': '', 'contact_phone': '' }
              return i18n.t(oMode.name)
            }
          })
          self.locations = data.locations
          self.dateRange = data.daterange
        })
      } else {
        return i18n.t(oMode.name)
      }
    },

    getTeamDivision (team_division) {
      if (!team_division) return '-'
      const team_divisions = this.$store.getters.getTeamDivision()

      return team_divisions[team_division] ? team_divisions[team_division].name : '-'
    },

    fnDestroy () {
      this.$destroy()
    },

    add (type) {
      this.$popup.searchperson({ type: type, entity: 'team', id: this.$route.params.id, title: i18n.t('search.person.title'), message: i18n.t('search.person.message'), btnSearch: i18n.t('search.person.label'), btnSuccess: i18n.t('create.' + type), btnCancel: i18n.t('cancel') })
    },

    changeModality (id, modality, e) {
      e.preventDefault()
      e.stopPropagation()

      var aStatus = {
        '1': { id: '1', name: 'Amb hospedatge' },
        '2': { id: '0', name: 'Sense hospedatge' }
      }
      var elem = document.getElementById('modality_' + id)
      var rect = elem.childNodes[0].getBoundingClientRect()
      var style = elem.childNodes[0].style
      var current_modality = modality
      modality = modality == '1' ? 2 : 1

      var self = this
      this.$comboSelector({
        values: aStatus,
        current: current_modality,
        style: {
          top: rect.bottom,
          left: rect.left,
          width: rect.width,
          backgroundColor: style.backgroundColor,
          color: style.color
        },
        callBackClose: function () {
          self.column_preview = false
          self.$comboSelector.close()
        },
        callBackSave: function (status) {
          var message = 'participants.change_modality.' + modality

          self.$popup.confirm(
            {
              message: i18n.t(message),
              btnSuccess: i18n.t('accept'),
              btnError: i18n.t('cancel')
            },
            function () {
              self.$overlay.loading()
              var path = 'persons/changeModality'
              self.$store
                .dispatch(path, {
                  id: id,
                  event_id: self.$store.getters[ 'events/getCurrentEvent']().id,
                  modality: modality
                })
                .then(function () {
                  self.$comboSelector.close()
                  self.loadData()
                })
            },
            function () {
              self.$comboSelector.close()
            }
          )
        }
      })
    },

    // ROOMING METHODS
    formatEntryDate () {
      this.newRooming.parsedEntryDate = moment(this.newRooming.start_date).format('DD/MM/YYYY')
    },

    formatDepartureDate () {
      this.newRooming.parsedDepartureDate = moment(this.newRooming.end_date).format('DD/MM/YYYY')
    },

    editRooming (item) {
      this.addRooming = true
      item.alergy = typeof item.alergy === 'boolean' ? (item.alergy ? 1 : 0) : parseInt(item.alergy)
      this.newRooming = { ...item }
      this.newRooming.visible = parseInt(this.newRooming.visible)
      this.calculatePaxRooms()
      this.formatEntryDate()
      this.formatDepartureDate()
      this.isEditRooming = true
    },

    addTravel () {
      var event_id = (this.$store.getters.isEventSelected) ? this.$store.getters[ 'events/getCurrentEvent' ]().id : false
      this.$router.push({ name: (event_id ? 'event_travels_add' : 'travels_add'), params: { entity_type: 2, entity_id: this.$route.params.id } })
    },

    editTravel (item) {
      var event_id = (this.$store.getters.isEventSelected) ? this.$store.getters[ 'events/getCurrentEvent' ]().id : false
      this.$router.push({ name: (event_id ? 'event_travels_card' : 'travels_card'), params: { id: item.id, event: this.$route.params.event } })
    },

    removeTravel (item) {
      var self = this
      var event_id = (this.$store.getters.isEventSelected) ? this.$store.getters[ 'events/getCurrentEvent' ]().id : false
      this.$popup.confirm(
        {
          message: i18n.t('travels.remove_message'),
          btnSuccess: i18n.t('accept'),
          btnError: i18n.t('cancel')
        },
        function () {
          self.$store.dispatch('travels/remove_relation', { travel_id: item.id, rel: self.team.id, type: 2 }).then(function () {
            var id = self.$route.params.id
            self.$store.dispatch('travels/loadTeamTravels', { team_id: id }).then(function () {})
          })
        }
      )
    },

    getLocationTransfer (entity_type, entity_id) {
      if (parseInt(entity_type) == 4) {
        return this.$store.getters['hotels/get_by_id'](entity_id)
      } else if (parseInt(entity_type) == 5) {
        return this.$store.getters['facilitys/get_by_id'](entity_id)
      } else if (parseInt(entity_type) == 11) {
        var locations = this.$store.getters['travels/getLocations']()
        return locations[entity_id] ? locations[entity_id] : ''
      }
    },

    calculatePaxRooms (room) {
      var item = this.newRooming
      var numRoomChanged = item['num_rooms_' + room + 'pax']

      if (parseInt(numRoomChanged) == NaN || parseInt(numRoomChanged) < 0) {
        this.newRooming['num_rooms_' + room + 'pax'] = 0
      }

      if (numRoomChanged != '') {
        this.pax = (parseInt(item.num_rooms_1pax) * 1) + (parseInt(item.num_rooms_2pax) * 2) + (parseInt(item.num_rooms_3pax) * 3) + (parseInt(item.num_rooms_4pax) * 4) + (parseInt(item.num_rooms_5pax) * 5)
        this.rooms = parseInt((parseInt(item.num_rooms_1pax)) + (parseInt(item.num_rooms_2pax)) + (parseInt(item.num_rooms_3pax)) + (parseInt(item.num_rooms_4pax)) + (parseInt(item.num_rooms_5pax)))
      }
    },

    closeRooming () {
      this.addRooming = false
      this.isEditRooming = false
      this.pax = 0
      this.rooms = 0
      this.error = { start_date: false, end_date: false }
      this.newRooming = {
        num_rooms_1pax: 0,
        num_rooms_2pax: 0,
        num_rooms_3pax: 0,
        num_rooms_4pax: 0,
        num_rooms_5pax: 0,
        alergy: false,
        status: '1'
      }
    },

    saveRooming () {
      var self = this
      var validate = true
      var id = this.$route.params.id
      var error = {}

      this.newRooming.parsedEntryDate == null || this.newRooming.parsedEntryDate == '' ? (error.start_date = true) && (validate = false) : error.start_date = false

      this.newRooming.parsedDepartureDate == null || this.newRooming.parsedDepartureDate == '' ? (error.end_date = true) && (validate = false) : error.end_date = false

      typeof this.newRooming.first_hotel_service_id === 'undefined' || this.newRooming.first_hotel_service_id == null || this.newRooming.first_hotel_service_id == '' ? (error.first_hotel_service_id = true) && (validate = false) : error.first_hotel_service_id = false

      typeof this.newRooming.last_hotel_service_id === 'undefined' || this.newRooming.last_hotel_service_id == '' ? (error.last_hotel_service_id = true) && (validate = false) : error.last_hotel_service_id = false

      this.newRooming.status == null || this.newRooming.status == '' ? (error.status = true) && (validate = false) : error.status = false

      if (validate && this.pax == this.total_pax) {
        if (moment(this.newRooming.end_date).isBefore(this.newRooming.start_date)) {
          this.$popup.alert({
            message: i18n.t('hotels.error_end_before_start'),
            btnSuccess: i18n.t('accept')
          })
          this.error.end_date = true
          return
        }

        this.newRooming.visible = this.newRooming.visible ? 1 : 0

        var event_id = (this.$store.getters.isEventSelected) ? this.$store.getters[ 'events/getCurrentEvent' ]().id : false

        this.$store.dispatch('teams/saveRooming', { team_id: id, event_id: event_id, data: JSON.parse(JSON.stringify(this.newRooming)), isEdit: this.isEditRooming }).then(function () {
          self.closeRooming()
          self.$store.dispatch('teams/loadRooming', { team_id: id, event_id: event_id }).then(function () {})
        })
      } else if (validate && this.pax != this.total_pax) {
        self.$popup.confirm(
          {
            message: i18n.t("El número de persones allotjades en el rooming no coincideix amb les introduides per l'equip. Vols continuar?"),
            btnSuccess: i18n.t('accept'),
            btnError: i18n.t('cancel')
          },
          function () {
            if (moment(self.newRooming.end_date).isBefore(self.newRooming.start_date)) {
              self.$popup.alert({
                message: i18n.t('hotels.error_end_before_start'),
                btnSuccess: i18n.t('accept')
              })
              self.error.end_date = true
              return
            }

            self.newRooming.visible = self.newRooming.visible ? 1 : 0

            var event_id = (self.$store.getters.isEventSelected) ? self.$store.getters[ 'events/getCurrentEvent' ]().id : false

            self.$store.dispatch('teams/saveRooming', { team_id: id, event_id: event_id, data: JSON.parse(JSON.stringify(self.newRooming)), isEdit: self.isEditRooming }).then(function () {
              self.closeRooming()
              self.$store.dispatch('teams/loadRooming', { team_id: id, event_id: event_id }).then(function () {})
            })
          },
          function () {}
        )
      } else {
        self.error = { ...error }
      }
    },

    deleteRooming (item) {
      var self = this
      var event_id = (this.$store.getters.isEventSelected) ? this.$store.getters[ 'events/getCurrentEvent' ]().id : false
      var id = this.$route.params.id

      this.$popup.confirm({
        message: i18n.t('hotels.delete_rooming'),
        btnSuccess: i18n.t('accept'),
        btnError: i18n.t('cancel')
      }, function () {
        self.$store.dispatch('teams/removeRooming', { team_id: id, event_id: event_id, rooming_id: item.id }).then(function () {
          self.$store.dispatch('teams/loadRooming', { team_id: id, event_id: event_id }).then(function () {})
        })
      },
      function () {
        self.$comboSelector.close()
      })
    },

    roomingStatus (v) {
      var status = this.$store.getters['hotels/getRoomingStatus'](v)
      return i18n.t(status.name)
    },

    downloadImage (url) {
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', url)
      document.body.appendChild(link)
      link.click()
    },

    sortTableTravels (items, sortBy, sortDesc, locale, customSorters) {
      items.sort((i1, i2) => {
        if (typeof i1.origin && i2.origin) {
          if (moment(i1.origin.date, 'DD-MM-YYYY').valueOf() > moment(i2.origin.date, 'DD-MM-YYYY').valueOf()) {
            return 1
          } else if (moment(i1.origin.date, 'DD-MM-YYYY').valueOf() < moment(i2.origin.date, 'DD-MM-YYYY').valueOf()) {
            return -1
          } else {
            if (moment(i1.origin.date + ' ' + i1.origin.hour, 'DD-MM-YYYY HH:mm').valueOf() > moment(i2.origin.date + ' ' + i2.origin.hour, 'DD-MM-YYYY HH:mm').valueOf()) {
              return 1
            }
            return -1
          }
          return -1
        } else if (i1.origin) {
          return -1
        } else if (i2.origin) {
          return 1
        } else {
          return 1
        }
        return 1
      })

      return items
    }
  },
  watch: {
    b_transfer_visible: {
      handler (v) {
        this.b_arribada_visible = this.b_transfer_visible
        this.b_sortida_visible = this.b_transfer_visible
        this.$store.dispatch('teams/updateTransferVisible', { team_id: this.$route.params.id, visible: (this.b_transfer_visible ? 1 : 0) })
      },
      deep: true
    },
    b_arribada_visible: {
      handler (v) {
        this.$store.dispatch('teams/updateArribadaVisible', { team_id: this.$route.params.id, visible: (this.b_arribada_visible ? 1 : 0) })
      },
      deep: true
    },
    b_sortida_visible: {
      handler (v) {
        this.$store.dispatch('teams/updateSortidaVisible', { team_id: this.$route.params.id, visible: (this.b_sortida_visible ? 1 : 0) })
      },
      deep: true
    },
    hotels_visible: {
      handler (v) {
        this.$store.dispatch('teams/updateHotelsVisible', { team_id: this.$route.params.id, visible: (this.hotels_visible ? 1 : 0) })
      },
      deep: true
    },
    $route: 'loadData'
  },
  filters: {
    insured (v) {
      var insuranceOptions = [
        { value: '0', name: i18n.t('nsnc') },
        { value: '1', name: i18n.t('si') },
        { value: '2', name: i18n.t('no') }
      ]
      if (insuranceOptions[ parseInt(v) ]) {
        return insuranceOptions[ parseInt(v) ].name
      } else return v
    },

    travelType (t) {
      return i18n.t('travels.travel_type_' + t)
    },

    parseBoolean(v) {
        return i18n.t('bool.' + (parseInt(v) == 0 || !v ? 'no' : 'si'))
    }
  }
}
</script>
<style lang="scss">
.section {
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 12px;
}
.name {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 8px;
}

#team {
  width: 100%;
  display: inline-block;

  #travels {
    table {
      table-layout: fixed !important;
      width: 100% !important;

      td {
        padding: 5px 5px;
        line-height: 16px;
      }

      th {
        overflow: hidden;
        width: 90px;
      }
    }
  }

  // 👇 Add styles for volunteer cards here
  .assigned-teams {
    margin-top: 10px;
  }

  .team-card {
    padding: 5px;
  }

  .team-name {
    font-weight: 600;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .club-name {
    font-size: 13px;
    color: #555;
    word-break: break-word;
  }

  .v-avatar {
    margin-right: 10px;

    img {
      border-radius: 50%;
      object-fit: cover;
    }
  }

  // Optional: card hover effect
  .team-card:hover {
    box-shadow: 0 2px 10px #00000022;
    transition: box-shadow 0.2s ease-in-out;
  }
  @media (max-width: 1370px) {
    .volunteer-card {
      flex: 0 0 50% !important;
      max-width: 50% !important;
    }
  }

  @media (max-width: 1090px) {
    .volunteer-card {
      flex: 0 0 100% !important;
      max-width: 100% !important;
    }
  }
}
</style>

<style lang="scss" scoped>
    #team {
        width: 100%;
        display: inline-block;

        #travels {
            td.shared {
                background-image: url(/img/bifurcation.svg);
                background-size: 15px;
                background-repeat: no-repeat;
                background-position: left 5px center;
                top: 0;
                left: 0;
                cursor: pointer;
                padding-left: 25px;
                border-left: 5px solid #ffc107;
            }
        }

        .container {
            width: calc( 100% - 350px);
            padding: 0px;
            max-width: 100%;

            &.main {
                overflow-y: auto;
                height: calc( 100vh - 110px );
            }

            .section-container {
                padding: 20px;

                &#basic {
                    background-color: #fff;
                    @include  box-shadow( $h: 0px , $v: 3px , $b: 8px , $s: 0px , $c: #00000011 );
                }
                &#notes {
                    background-color: $complem-color-light;
                }
                &#teams {
                    background-color: #fff;
                    @include  box-shadow( $h: 0px , $v: -3px , $b: 8px , $s: 0px , $c: #00000011 );
                }
            }

        }

        .contact {
            width: 20%;
            width: 350px;
            padding: 20px;
        }

        .logo {
            width: 250px;
            height: 250px;
            border: 1px solid #eee;
            position: relative;

            img {
                object-fit: contain;
                object-position: center;
                height: 170px;
                width: auto;
                margin: 0 auto;
                display: block;
                padding-top: 10px;
            }

            .download {
                width: 40px;
                height: 40px;
                position: absolute;
                background-image: url(/img/download.svg);
                background-color: #000;
                background-size: 30px;
                background-repeat: no-repeat;
                background-position: center;
                top: 0;
                right: 0;
                cursor: pointer;
            }

            .legend {
                width: 100%;
                height: 40px;
                text-align: center;
                font-weight: lighter;
                line-height: 36px;
                padding: 4px;
                font-size: 18px;
                background: #222;
                color: #fff;
                text-transform: uppercase;

                &.cat {
                    font-size: 30px;
                    line-height: 20px;
                    font-family: Roboto-Bold;
                }
            }
        }

        .alert-info {
            padding: 0.75rem 1.25rem;
            margin-bottom: 1rem;
            border: 1px solid transparent;
            border-radius: 0.25rem;
            color: #856404;
            background-color: #fff3cd;
            border-color: #ffeeba;
        }

        .info {

            .container {
                margin: 0;
                padding: 0 20px;
                padding-left: 40px;
                width: 100%;

                .section {
                    margin-bottom: 75px;

                    .name {
                        font-weight: lighter;
                        font-size: 24px;
                        @include font-size(14px);
                        border-bottom: 1px solid #ddd;
                        margin: 10px 0 20px 0;
                        color: $main-color;
                        text-transform: uppercase;
                        margin-bottom: 20px;
                        border-bottom: 2px solid $complem-color-dark;
                        color: $complem-color-dark;
                        position: relative;
                        width: fit-content;
                        cursor: pointer;
                        padding-bottom: 5px;
                        font-family: Roboto-Bold;

                        &::after {
                            content: "";
                            width: 30px;
                            height: 15px;
                            background: url(/img/down.svg);
                            background-repeat: no-repeat;
                            background-size: 15px;
                            background-position: center right;
                            position: absolute;
                        }

                        .add {
                            content: "";
                            position: absolute;
                            /* width: 40px; */
                            /* height: 25px; */
                            /* border: 1px solid #000; */
                            /* border-radius: 50%; */
                            background: url(/img/add_b.svg);
                            background-repeat: no-repeat;
                            background-size: 12px;
                            background-position: left center;
                            padding-left: 20px;
                            top: -5px;
                            right: 0;
                            font-size: 14px;
                        }
                    }

                    .label {
                        font-family: $text-light;
                        @include font-size(14px);
                        width: 40%;
                        float: left;
                        line-height: 20px;

                        &.empty {
                            opacity: 0;
                        }
                    }

                    .value {
                        font-family: $text;
                        font-weight: lighter;
                        @include font-size(14px);
                        width: 60%;
                        float: left;
                        margin-bottom: 10px;

                        &.empty {
                            opacity: 0;
                        }

                        a {
                            font-weight: bold;
                            font-size: 16px;

                            &.club {
                                padding-left: 20px;
                                background: url(/img/club.svg);
                                background-size: 15px;
                                background-position: center left;
                                background-repeat: no-repeat;
                            }
                        }
                    }
                }
            }
        }

        .table-header {
            .column {
                padding-left: 10px !important;
                text-align: left !important;
            }
        }
    }

    .inlineblock {
        display: inline-block;
    }

    .popup {
        .counter {
            background-color: #eee;
            padding: 3px 10px;
            margin: 0px 10px;
            color: #888;
            font-size: 18px;
            cursor: default;
        }

        .label {
            &.error {
                color: $alert-color;
                font-weight: bold;
            }
        }

        .input-error {
            border: 1px solid red !important;
        }

        .item {
            width: 90%;
            margin-bottom: 20px;
        }

        .rooms {
            margin: 30px 0px;

            .room {
                width: calc(100% / 5);

                .room-quantity {
                    width: 40px;
                    border: 1px solid black;
                    text-align: center;
                    padding: 5px;
                    margin: 0px 5px;

                    &.disabled {
                        background: #eee;
                        color: #acacac;
                    }
                }
            }
        }
    }

    #budget_control {
        &.visible {
            background-color: #ebf6eb;
        }
    }
</style>

<style lang="scss">

    @media only screen and (max-width: 1000px) {
        #container {

            .container {
               width: 100% !important;
               max-width: 100% !important;

               &.main {
                   overflow-y: auto;
                   height: auto !important;
               }
            }

            .info .container {
                padding: 0 !important;
            }
        }

    }
.chip-text-force {
  color: #fff !important;
  white-space: nowrap !important;
  letter-spacing: 0.3px !important;
}
.v-btn.v-btn--icon {
  min-width: 24px;
  height: 24px;
}
.v-card-text ul {
  list-style-type: disc;
  padding-left: 1.5em;
}
.v-card-title {
  font-weight: 600;
}
</style>
